module.exports = __webpack_public_path__ + "img/brigitte_lamy.8046a493.jpeg";